<template>
    <div id="userLogin">
        <div>
            <h2>
                <!-- <svg class="icon" aria-hidden="true">
            <use xlink:href="#se-icon-elephant"></use>
          </svg> -->
                <span>实名专用链接</span>
            </h2>
            <form>
                <div>
                    <keep-alive>
                        <se-autocomplete v-model="iccid" :fetchsuggestions="querySearch" @select="handleSelect"
                            placeholder="请输入实名卡号"></se-autocomplete>
                    </keep-alive>
                </div>
                <div class="formLine">
                    <mt-button type="primary" style="background:#0066FF" size="large"
                        @click.prevent="userQuerySIM">进行实名登记</mt-button>
                </div>
            </form>
        </div>

        <p style="text-align: center;font-size: 10px;margin-top:1rem;color:red">提醒：实名成功后 开下飞行模式即可畅享网络。</p>
        <!-- <img
        style="width: 100%; margin-top: 1rem;"
        src="@/assets/advertising3.jpg"
        alt=""
        @click="goto('http://szyanyun.com/download.html')"
      /> -->
        <!-- <button class="download" @click="goto('http://szyanyun.com/download.html')" >点击下载</button> -->

        <!-- <Advertisement></Advertisement> -->
    </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
    components: { SeAutocomplete, Advertisement },
    data() {
        return {
            iccid: "",
            code: "",
            showAds: true,
            gzh: "",
            simInfo: {}
        };
    },
    methods: {
        querySearch(queryString, cb) {
            var listAll = this.getAutoCompleteData("iccidList");
            var results = queryString
                ? listAll.filter(this.createFilter(queryString))
                : listAll;
            cb(results);
        },
        createFilter(queryString) {
            return (listAll) => {
                return listAll.indexOf(queryString) == 0;
            };
        },
        handleSelect(item) {
            this.iccid = item;
        },
        userQuerySIM() {
            if (!this.iccid || this.iccid == "") {
                Dialog.alert({ title: "提示", message: "请输入实名卡号" });
                return false;
            }
            wxRequest("sim/detail", { iccid: this.iccid }, "post").then((res) => {
                if (res.data.code === '200') {
                    this.simInfo = res.data.data
                    var simpkg = {
                        iccid: this.simInfo.iccid,
                    };
                    let iccid = this.simInfo.iccid;
                    let intoNo = this.simInfo.intoNo;
                    localStorage.setItem('intoNo', res.data.data.intoNo)
                    localStorage.setItem('iccid', res.data.data.iccid)
                    if (this.simInfo.flowRatePool == '电信') {
                        this.$router.push({
                            path: "/user/ctccAuth",
                            query: { realNameCard: 1 },
                        });
                    } else if (this.simInfo.flowRatePool == '联通') {
                        window.location.href = "http://vx.iot688.cn/#/user/cuccAuth";
                    } else if (this.simInfo.flowRatePool == '移动') {
                        this.$router.push({
                            path: "/user/cmccAuth",
                            query: { realNameCard: 1 },
                        });
                    } else if (this.simInfo.flowRatePool == '移动接口') {
                        wxRequest("wxAuth/cmcc/auth", { iccid: iccid }, "post").then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    } else if (this.simInfo.flowRatePool == '5G电信') {
                        wxRequest(
                            "wxAuth/ctcc/to/5G/auth",
                            { iccid: this.simInfo.iccid },
                            "post"
                        ).then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    } else if (this.simInfo.flowRatePool == '电信接口') {
                        wxRequest(
                            "wxAuth/ctcc/to/auth",
                            { iccid: this.simInfo.iccid },
                            "post"
                        ).then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    } else if (this.simInfo.flowRatePool == '广电') {
                        this.$router.push('/user/ctccGdAuth');
                    } else if (this.simInfo.flowRatePool == '假实名') {
                        this.$router.push('/user/bindPhoneAuth');
                    } else {
                        window.localStorage.href = this.simInfo.flowRatePool;
                    }
                } else {
                    Toast.fail(res.data.message);
                }
            })
        },

        //获取url参数
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return false;
        },

        goto(path) {
            //广告点击统计
            window.location.href = path;
        },
    },
    created() {
        var source = this.getQueryVariable("source")
            ? this.getQueryVariable("source")
            : process.env.VUE_APP_APPID;
        localStorage.setItem("appid", source);
        localStorage.setItem("isHeadquarterAppid", false);
        var appid = source ? source : process.env.VUE_APP_APPID;
        this.$store.commit("setIsHeadquarterAppid", "true");
        localStorage.setItem("isHeadquarterAppid", true);
    },

    mounted() { },

    beforeDestory() { },
};
</script>
  
<style lang="less" scoped>
.download {
    position: relative;
    top: -63px;
    background: #ff9c3c;
    border: none;
    padding: 7px 13px;
    border-radius: 25px;
    font-size: 12px;
    color: #fff;
    left: 20%;
}
</style>
  